<app-toolbar></app-toolbar>

<div class="gdl-container">
  <!-- Header con botón de refresh -->
  <div class="header">
    <div>
      <h1>ECS Software Engineering Projects</h1>
    </div>

    <button
      class="refresh-button"
      (click)="refreshData()"
      [disabled]="isRefreshing"
      [class.refreshing]="isRefreshing"
      title="Refresh data"
    >
      <span class="icon" [class.spinning]="isRefreshing">⟳</span>
      <span *ngIf="!isRefreshing">Refresh</span>
      <span *ngIf="isRefreshing">Refreshing...</span>
    </button>
  </div>

  <!-- Skeleton loading state -->
  <div class="skeleton-table" *ngIf="isInitialLoading">
    <div class="skeleton-search"></div>
    <table class="skeleton-inner-table">
      <thead>
        <tr>
          <th><div class="skeleton-cell header"></div></th>
          <th><div class="skeleton-cell header"></div></th>
          <th><div class="skeleton-cell header short"></div></th>
          <th><div class="skeleton-cell header short"></div></th>
          <th><div class="skeleton-cell header short"></div></th>
          <th><div class="skeleton-cell header"></div></th>
          <th><div class="skeleton-cell header short"></div></th>
          <th><div class="skeleton-cell header"></div></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of [1, 2, 3, 4, 5, 6, 7]" class="skeleton-row">
          <td><div class="skeleton-cell"></div></td>
          <td><div class="skeleton-cell medium"></div></td>
          <td><div class="skeleton-cell short"></div></td>
          <td><div class="skeleton-cell short"></div></td>
          <td><div class="skeleton-cell pill"></div></td>
          <td><div class="skeleton-cell short"></div></td>
          <td><div class="skeleton-cell pill"></div></td>
          <td><div class="skeleton-cell long"></div></td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Tabla de datos -->
  <app-tabla *ngIf="!isInitialLoading" [ec2Repositories]="demo"></app-tabla>

  <!-- Empty state -->
  <div class="empty-state" *ngIf="!isInitialLoading && demo.length === 0">
    <p>No projects found</p>
    <button (click)="refreshData()">Try Again</button>
  </div>
</div>
